import { useIntl } from 'react-intl';
import { useHistory } from 'react-router';
import { IconLayoutGrid } from '@rossum/ui/icons/tabler';
import { Button, Stack, SvgIcon, Typography } from '@rossum/ui/material';
import { extensionsStorePath } from '../../../../routes';

type Props = {
  withBackground?: boolean;
};

export const StoreAdBanner = ({ withBackground }: Props) => {
  const intl = useIntl();
  const history = useHistory();

  return (
    <Stack
      py={6}
      px={4}
      alignItems="center"
      sx={withBackground ? { backgroundColor: 'background.paper' } : {}}
      data-cy="extensions-ad-banner"
    >
      <SvgIcon color="secondary" fontSize="xLarge">
        <IconLayoutGrid />
      </SvgIcon>
      <Typography variant="h6" mt={1}>
        {intl.formatMessage({
          id: 'containers.settings.extensions.adBanner.title',
        })}
      </Typography>
      <Typography variant="body2" color="text.secondary" mt={1}>
        {intl.formatMessage({
          id: 'containers.settings.extensions.adBanner.subtitle',
        })}
      </Typography>
      <Button
        variant="outlined"
        color="secondary"
        onClick={() => history.push(extensionsStorePath())}
        sx={{ mt: 2.5 }}
      >
        {intl.formatMessage({
          id: 'containers.settings.extensions.adBanner.button',
        })}
      </Button>
    </Stack>
  );
};
